import { render, staticRenderFns } from "./UiDisplayInput.vue?vue&type=template&id=4a7de029&"
import script from "./UiDisplayInput.vue?vue&type=script&lang=js&"
export * from "./UiDisplayInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports